<template>
  <d-modal-confirmation
    :title="modalTitle"
    :text="modalConfirmationText"
    :modal="modal"
    :submitButtonText="modalSubmitButtonText"
    @closeModal="handleCloseModal"
    @submitModal="handleSubmitModal"
    :isSubmitting="isSubmitting"
  >
  </d-modal-confirmation>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  computed: {
    modalTitle() {
      return this.$t("users.change-status.title", {
        action: this.item.isActive
          ? this.$t(`users.change-status.button.deactivate`)
          : this.$t(`users.change-status.button.activate`),
      });
    },
    modalConfirmationText() {
      return this.$t("users.change-status.text", {
        action: this.item.isActive
          ? this.$t(`users.change-status.button.deactivate`).toLowerCase()
          : this.$t(`users.change-status.button.activate`).toLowerCase(),
        fullName: this.item.fullName,
      });
    },
    modalSubmitButtonText() {
      return this.item.isActive
        ? this.$t(`users.change-status.button.deactivate`)
        : this.$t(`users.change-status.button.activate`);
    },
  },
  methods: {
    handleCloseModal() {
      this.$emit("closeModal");
    },
    handleSubmitModal() {
      this.item.isActive ? this.deactivateUser() : this.activateUser();
    },
    activateUser() {
      this.isSubmitting = true;
      window.API.activateUser(this.item.id)
        .then(() => {
          this.$eventBus.$emit("notification", {
            type: "success",
            message: this.$t("users.change-status.alert.activated", {
              fullName: this.item.fullName,
            }),
          });
          this.$emit("submitModal");
          this.handleCloseModal();
        })
        .catch(() => {
          this.$eventBus.$emit("notification", {
            type: "error",
            message: this.$t("users.change-status.alert.could-not-activate"),
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    deactivateUser() {
      this.isSubmitting = true;
      window.API.deactivateUser(this.item.id)
        .then(() => {
          this.$eventBus.$emit("notification", {
            type: "success",
            message: this.$t("users.change-status.alert.deactivated", {
              fullName: this.item.fullName,
            }),
          });
          this.$emit("submitModal");
          this.handleCloseModal();
        })
        .catch(() => {
          this.$eventBus.$emit("notification", {
            type: "error",
            message: this.$t("users.change-status.alert.could-not-deactivate"),
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
